import { useEffect, useState } from "react";
import "../../styles/UserDashboard/OnboardingTemplate.scss";
import { submitBusinessTemplate } from "../../apis/General/users";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
// import { countries } from "../../data/countries";

export default function BusinessOnboardingTemplates() {
  const auth = useSelector((state) => state.auth);
  const pathname = useLocation();
  const params = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [industry, setIndustry] = useState("");
  const [facilityCategory, setFacilityCategory] = useState("");
  const [subCcv, setSubCcv] = useState("");
  // const [country, setCountry] = useState("");
  const [walletAddress, setWalletAddress] = useState("");
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorText, setErrorText] = useState("hello");
  const [errorTitle, setErrorTitle] = useState("hello");
  const [errorButtonAction, setErrorButtonAction] = useState("login");
  const [userId, setUserId] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);

  useEffect(() => {
    if (params?.verifier?.toLowerCase() === "echon") {
      setSubCcv(params?.verifier?.toLowerCase());
    }
  }, [params]);

  const isFormValid = () => {
    return (
      firstName.trim() &&
      lastName.trim() &&
      email.trim() &&
      companyName.trim() &&
      industry.trim() &&
      facilityCategory.trim() &&
      // country.trim() &&
      walletAddress.trim() &&
      termsAccepted
    );
  };

  const handleShowError = (title, body, action = "ok") => {
    setErrorTitle(title);
    setErrorText(body);
    setErrorButtonAction(action);
    setErrorModalOpen(true);
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    if (!/^(0x)[0-9a-f]{40}$/i.test(walletAddress)) {
      alert("Invalid wallet address");
      setLoading(false);
      return false;
    }
    // console.log("SUBMITTING:", 
    //   firstName,
    //   lastName,
    //   email,
    //   industry,
    //   country,
    //   subCcv,
    //   facilityCategory,
    //   walletAddress,
    //   submission_by: params?.verifier?.toLowerCase() === "echon" ? "verifier" : "user",
    //   token: auth?.token
    // });
    const response = await submitBusinessTemplate({
      subscriptionPlan: pathname?.pathname?.split('/')[2],
      firstName,
      lastName,
      email,
      companyName,
      industry,
      // country,
      subCcv,
      facilityCategory,
      walletAddress,
      submission_by: params?.verifier?.toLowerCase() === "echon" ? "verifier" : "user",
      token: auth?.token
    });

    if (response?.data?.statusCode === 200) {
      if (params?.verifier?.toLowerCase() === "echon") {
        navigate(`/signup/${response.data.message}`);
      } else {
        navigate(`/plans/business/pay/${response.data.message}`);
      }
      localStorage.setItem("demosent", "true");
    } else if (
      response?.data?.message === "This email has been registered. Kindly login"
    ) {
      handleShowError(
        "Oops email already registered",
        "It appears this email has already been registered. If you've forgotten your password, click 'Forgot Password' on the login screen.",
        "login"
      );
    } else if (
      response?.data?.message === "KYC submitted. Kindly verify your email."
    ) {
      handleShowError(
        "Oops email already existed",
        "This email already exists. Kindly click the button below to input the otp sent to your email to activate or request for a new OTP",
        "otp"
      );
      setUserId(response?.data?.userId);
    } else if (
      response?.data?.message === "This email has been registered. Kindly complete the sign up process"
    ) {
      handleShowError(
        "Oops email already registered",
        "It appears this email has already been registered. Kindly click the button below to complete the sign up process",
        "register"
      );
      setUserId(response?.data?.userId);
    } else {
      toast.error(response?.data?.message);
    }

    setLoading(false);
  };

  const handleErrorModalClose = (e) => {
    if (e.target.classList.contains("errorModal")) {
      setErrorModalOpen(false);
    }
  };

  return (
    <div className="onboarding-template">
      <div className="onboarding-template__title">
        Almost there! Tell us about your facility for a perfect fit.
      </div>
      <div className="onboarding-template__subtitle">
        Fill this simple form to help us understand your facility.
      </div>
      <form onSubmit={handleSubmit}>
        <label className="onboarding-template__input-label" htmlFor="firstName">
          First name
        </label>
        <input
          className="onboarding-template__input"
          required
          id="firstName"
          type="text"
          placeholder="Enter your first name"
          name="firstName"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />

        <label className="onboarding-template__input-label" htmlFor="lastName">
          Last name
        </label>
        <input
          className="onboarding-template__input"
          required
          id="lastName"
          type="text"
          placeholder="Enter your last name"
          name="lastName"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />

        <label className="onboarding-template__input-label" htmlFor="email">
          Email
        </label>
        <input
          className="onboarding-template__input"
          required
          id="email"
          type="email"
          placeholder="Enter email address"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        {/* <label className="onboarding-template__input-label" htmlFor="country">
          Country
        </label>
        <select
          className="onboarding-template__input onboarding-template__input-select"
          required
          id="country"
          value={country}
          onChange={(e) => setCountry(e.target.value)}
        >
          <option value="">Select country</option>
          {countries?.map((country, index) => (
            <option key={index} value={country?.label}>
              {country?.label}
            </option>
          ))}
        </select> */}


        <label
          className="onboarding-template__input-label"
          htmlFor="lastName"
        >
          Company name
        </label>

        <input
          className="onboarding-template__input"
          required
          id="companyName"
          type="text"
          placeholder="Enter company  name"
          name="companyName"
          value={companyName}
          onChange={(e) => setCompanyName(e.target.value)}
        />


        <label className="onboarding-template__input-label" htmlFor="industry">
          Industry
        </label>
        <input
          className="onboarding-template__input"
          required
          id="industry"
          type="text"
          placeholder="Enter the industry your company falls under e.g food industry, oil and gas"
          name="industry"
          value={industry}
          onChange={(e) => setIndustry(e.target.value)}
        />

        <label className="onboarding-template__input-label" htmlFor="subCcv">
          Sub-CCV
        </label>
        <select
          className="onboarding-template__input onboarding-template__input-select"
          id="subCcv"
          value={subCcv}
          onChange={(e) => setSubCcv(e.target.value)}
        >
          <option value="">Select a Sub-CCV</option>
          <option value="echon">ECHON</option>
          <option value="none">none</option>

        </select>

        <label
          className="onboarding-template__input-label"
          htmlFor="facilityCategory"
        >
          Facility category
        </label>
        <select
          className="onboarding-template__input onboarding-template__input-select"
          required
          id="facilityCategory"
          value={facilityCategory}
          onChange={(e) => setFacilityCategory(e.target.value)}
        >
          <option value="">Select facility  category</option>
          <option value="green">Green</option>
          <option value="non-green">Non-green</option>
          <option value="carbon-monitoring">Monitoring</option>
        </select>

        <label className="onboarding-template__input-label" htmlFor="walletAddress">
          Wallet address
        </label>
        <div className="onboarding-template__info">
          You can create a wallet and get an address on the <a href="https://metamask.io/" target="_blank" >MetaMask</a> website
        </div>
        <input
          className="onboarding-template__input"
          required
          id="walletAddress"
          type="text"
          placeholder="Enter your Ethereum Wallet Address (e.g., 0x1234...abcd)"
          name="walletAddress"
          value={walletAddress}
          onChange={(e) => setWalletAddress(e.target.value)}
        />
        <div className="onboarding-template__input-text">
          Note: Do not disclose your private key.
        </div>

        <div className="onboarding-template__container">
          <div className="onboarding-template__checkbox-wrapper">
            {!termsAccepted && (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => setTermsAccepted(true)}
                style={{ cursor: 'pointer' }}
              >
                <rect x="1.5" y="1.5" width="21" height="21" rx="5" stroke="url(#paint0_linear_2889_18043)" strokeWidth="1.5" />
                <defs>
                  <linearGradient id="paint0_linear_2889_18043" x1="1.5" y1="1.82" x2="26.76" y2="14.38" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#006633" />
                    <stop offset="1" stopColor="#02A4CC" />
                  </linearGradient>
                </defs>
              </svg>
            )}

            {termsAccepted && (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => setTermsAccepted(false)}
                style={{ cursor: 'pointer' }}
              >
                <rect x="1.5" y="1.5" width="21" height="21" rx="5" stroke="url(#paint0_linear_2889_18037)" strokeWidth="1.5" />
                <path d="M7 12.5L10.5 16L17 9" stroke="url(#paint1_linear_2889_18037)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <defs>
                  <linearGradient id="paint0_linear_2889_18037" x1="1.5" y1="1.82" x2="26.76" y2="14.38" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#006633" />
                    <stop offset="1" stopColor="#02A4CC" />
                  </linearGradient>
                  <linearGradient id="paint1_linear_2889_18037" x1="7" y1="9.26" x2="17.03" y2="15.74" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#006633" />
                    <stop offset="1" stopColor="#02A4CC" />
                  </linearGradient>
                </defs>
              </svg>
            )}
          </div>

          <label className="onboarding-template__label" style={{ cursor: 'pointer' }} onClick={() => setTermsAccepted(!termsAccepted)}>
            <span>I confirm that I have read and agree to the</span>
            <a href="/privacy-policy" className="onboarding-template__link">
              <span> Privacy Policy and Terms & Conditions </span>
            </a>
            <span>for CloseCarbon.</span>
          </label>
        </div>

        <button
          className="onboarding-template__button"
          type="submit"
          disabled={loading || !isFormValid()}
        >
          <div>{loading ? "Loading..." : "Done"}</div>
        </button>
      </form>

      {/* Error Modal */}
      {errorModalOpen && (
        <div className="errorModal" onClick={handleErrorModalClose}></div>
      )}
      {errorModalOpen && (
        <div className="error_modal">
          <div className="modal_title">{errorTitle}</div>
          <div className="modal_subtitle">{errorText}</div>
          {errorButtonAction === "login" ? (
            <button
              className="error_modal_button"
              type="submit"
              onClick={() => navigate("/login")}
              disabled={loading}
            >
              {loading ? "Loading..." : "Login"}
            </button>
          ) : errorButtonAction === "register" ? (
            <button
              className="error_modal_button"
              type="submit"
              onClick={() => navigate(`/signup/${userId}/3`)}
              disabled={loading}
            >
              {loading ? "Loading..." : "Okay"}
            </button>
          ) : errorButtonAction === "otp" ? (
            <button
              className="error_modal_button"
              type="submit"
              onClick={() => navigate(`/signup/${userId}`)}
              disabled={loading}
            >
              {loading ? "Loading..." : "Okay"}
            </button>
          ) : (
            <button
              className="error_modal_button"
              type="submit"
              onClick={() => setErrorModalOpen(false)}
              disabled={loading}
            >
              {loading ? "Loading..." : "Okay"}
            </button>
          )}
        </div>
      )}
    </div>
  );
}